import http from 'core/http.service';
import BaseService from 'services/BaseService';
import { Page } from 'models/page';
import { StockDTO, StockSearchDTO } from 'models/stock';

class StockService extends BaseService {
    // ===== 기본 CRUD 메소드 =====

    /** 재고 목록 조회 */
    public list(search: StockSearchDTO): Promise<Page<StockDTO>> {
        return super.request(http.get('/stock', search));
    }

    /** 재고 상세 조회 (ID) */
    public get(id: number): Promise<StockDTO> {
        return super.request(http.get(`/stock/${id}`));
    }

    /** 재고 저장 (신규/수정) */
    public save(dto: StockDTO): Promise<StockDTO> {
        return super.request(http.post('/stock', dto));
    }

    /** 재고 삭제 */
    public remove(id: number): Promise<void> {
        return super.request(http.delete(`/stock/${id}`));
    }

    /** 재고 증가 */
    public increaseStock(productCode: string, quantity: number): Promise<StockDTO> {
        return super.request(http.post('/stock/increase', { productCode, quantity }));
    }

    /** 재고 감소 */
    public decreaseStock(productCode: string, quantity: number): Promise<StockDTO> {
        return super.request(http.post('/stock/decrease', { productCode, quantity }));
    }

}

const stockService = new StockService();
export default stockService;